<template>
    <v-card outlined class="my-3 text-center area__sty">
        <span class="title__sty">{{$t('ProductPriceInfos_title1_1')}}<br />「{{ paytypeName }}」<br />{{$t('ProductPriceInfos_title1_2')}}</span>
        <p class="subtitle__sty">
            NT$ <font>{{ this.$store.state.shippingprice.shippingpriceData.totalshippingfee + this.$store.state.shippingprice.shippingpriceData.price - this.$store.state.couponpoint.starprice - this.$store.state.couponpoint.couponprice -this.$store.state.couponpoint.shopprice }}</font>
        </p>
    </v-card>
</template>

<script>
    export default {
        name: 'ProductPriceInfos',
        props: [],

        computed: {
        paytypeName() {
            // 信用卡付款: 1 貨到付款: 2 Line Pay: 3 aftee: 4
            if (this.$store.state.paytype === 1) {
                return this.$t('credit_card');
            } else if (this.$store.state.paytype === 2) {
                return this.$t('home');
            } else if (this.$store.state.paytype === 3) {
                return this.$t('line_pay');
            } else if (this.$store.state.paytype === 4) {
                return this.$t('aftee');
            } else if (this.$store.state.paytype === 6) {
                return this.$t('atm');
            } else {
                return '未選擇付款方式';
            }
        },
        },
        data: () => ({
        }),
        methods: {
        },
        mounted() {
        }
    }
</script>

<style scoped lang="sass">
    .theme--light.v-card.v-sheet--outlined
        border: none
    .area__sty
        background-color: #F2F2F2
    .title__sty
        color: #352D40
        font-weight: bold
        font-size: 15px
        letter-spacing: 0.1em
    .subtitle__sty
        color: #FF781E
        font-weight: bold
        font-size: 15px
        letter-spacing: 0.1em
    .subtitle__sty font
        font-size: 30px
        letter-spacing: 0em
</style>
